import { 
    getTenants,
    getUsers,
    sendTenantInvite, 
    acceptTenantInvite,
    rejectTenantInvite,
    getSentTenantInvites,
    sendUserInvite,
    acceptUserInvite,
    rejectUserInvite,  
    getSentUserInvites,
    getReceivedInvites, 
    removeUser as requestLeaveOrganization, 
    removeTenant as removeTenantFromOrg,
    provisionTenantAndOrUser,

} from '../../sources/organization';
import { fetchCurrentUser } from './currentUser';
import { fetchCurrentTenant } from './currentTenant';
import { addNotification } from './notification';
import actionTypes from './actionTypes';
import { notificationTypes } from '../../constants';
import translations from '../../translations';
import { stringReplace } from '../../utils/core';
import { resolveOrgUserRole } from '../../components/flowOrganization/InitialOrgPage';

export const fetchTenants = () => async (dispatch, getState) => {

    const { authenticationToken, tenantId } = getState().currentUser;
    
    try {
        const tenants = await getTenants({
            authenticationToken,
            tenantId,
        });

        dispatch({
            type: actionTypes.ORGANIZATION_TENANTS_SET_ALL,
            payload: tenants,
        });

    } catch (err) {
        dispatch(addNotification({
            type: notificationTypes.ERROR,
            message: err.message,
            isPersistent: true,
        }));
    }
};

export const fetchUsers = () => async (dispatch, getState) => {

    const { authenticationToken, tenantId } = getState().currentUser;
    
    try {
        const users = await getUsers({
            authenticationToken,
            tenantId,
        });

        dispatch({
            type: actionTypes.ORGANIZATION_USERS_SET_ALL,
            payload: users,
        });

    } catch (err) {
        dispatch(addNotification({
            type: notificationTypes.ERROR,
            message: err.message,
            isPersistent: true,
        }));
    }
};

export const fetchReceivedInvitations = () => async (dispatch, getState) => {
    
    const { authenticationToken, tenantId, id: userId } = getState().currentUser;
    
    try {
        const receivedInvitations = await getReceivedInvites({
            authenticationToken,
        });

        dispatch({
            type: actionTypes.ORGANIZATION_SET_RECEIVED_INVITATIONS,
            payload: {
                receivedInvitations,
                userId, 
                tenantId,
            },
        });

    } catch (err) {
        dispatch(addNotification({
            type: notificationTypes.ERROR,
            message: err.message,
            isPersistent: true,
        }));
    }
};

export const fetchSentTenantInvitations = ({ authenticationToken, tenantId, userId }) => async (dispatch) => {
    
    try {
        const sentInvitations = await getSentTenantInvites({
            authenticationToken,
            tenantId,
        });

        dispatch({
            type: actionTypes.ORGANIZATION_SET_SENT_TENANT_INVITATIONS,
            payload: {
                sentInvitations,
                tenantId, 
                userId,
            },
        });

    } catch (err) {
        dispatch(addNotification({
            type: notificationTypes.ERROR,
            message: err.message,
            isPersistent: true,
        }));
    }
};

export const fetchSentUserInvitations = ({ authenticationToken, tenantId, userId }) => async (dispatch) => {
    
    try {
        const sentInvitations = await getSentUserInvites({
            authenticationToken,
        });

        dispatch({
            type: actionTypes.ORGANIZATION_SET_SENT_USER_INVITATIONS,
            payload: {
                sentInvitations,
                tenantId, 
                userId,
            },
        });

    } catch (err) {
        dispatch(addNotification({
            type: notificationTypes.ERROR,
            message: err.message,
            isPersistent: true,
        }));
    }
};

export const sendTenantInvitation = ({ inviteTenantData }) => async (dispatch, getState) => {

    const { authenticationToken, tenantId, id: userId } = getState().currentUser;

    try {
        await sendTenantInvite({
            authenticationToken,
            tenantId,
            invitationTenantName: inviteTenantData.developerName, 
            invitationTenantId: inviteTenantData.id,
        });

        dispatch(addNotification({
            type: notificationTypes.SUCCESS,
            message: 'Invitation was sent',
        }));

        dispatch(fetchReceivedInvitations());
        dispatch(fetchSentTenantInvitations({ authenticationToken, tenantId, userId }));

    } catch (err) {
        dispatch(addNotification({
            type: notificationTypes.ERROR,
            message: err.message,
            isPersistent: true,
        }));
    }
};

export const sendUserInvitation = ({ inviteUserData }) => async (dispatch, getState) => {

    const { authenticationToken, tenantId, id: userId } = getState().currentUser;

    try {
        await sendUserInvite({
            authenticationToken,
            invitationEmail: inviteUserData.email, 
            invitationUserId: inviteUserData.id,
        });

        dispatch(addNotification({
            type: notificationTypes.SUCCESS,
            message: 'Invitation was sent',
        }));

        dispatch(fetchReceivedInvitations());
        dispatch(fetchSentUserInvitations({ authenticationToken, tenantId, userId }));

    } catch (err) {
        dispatch(addNotification({
            type: notificationTypes.ERROR,
            message: err.message,
            isPersistent: true,
        }));
    }
};

export const acceptTenantInvitation = ({ organizationId, authenticationToken, tenantId }) => async (dispatch) => {
    try {
        await acceptTenantInvite({
            authenticationToken,
            tenantId,
            organizationId,
        });
        
        // reload the user to pickup organization changes 
        dispatch(fetchCurrentUser(authenticationToken));
        dispatch(fetchCurrentTenant(authenticationToken, tenantId));
        dispatch(fetchReceivedInvitations());

    } catch (err) {
        dispatch(addNotification({
            type: notificationTypes.ERROR,
            message: err.message,
            isPersistent: true,
        }));
    }
};

export const rejectTenantInvitation = ({ organizationId, authenticationToken, tenantId }) => async (dispatch) => {
    try {
        await rejectTenantInvite({
            authenticationToken,
            tenantId,
            organizationId,
        });

        dispatch(fetchReceivedInvitations());
    } catch (err) {
        dispatch(addNotification({
            type: notificationTypes.ERROR,
            message: err.message,
            isPersistent: true,
        }));
    }
};

export const acceptUserInvitation = ({ organizationId, authenticationToken, tenantId }) => async (dispatch) => {
    try {
        await acceptUserInvite({
            authenticationToken,
            tenantId,
            organizationId,
        });
        
        // reload the user to pickup organization changes 
        dispatch(fetchCurrentUser(authenticationToken));
        dispatch(fetchReceivedInvitations());

    } catch (err) {
        dispatch(addNotification({
            type: notificationTypes.ERROR,
            message: err.message,
            isPersistent: true,
        }));
    }
};

export const rejectUserInvitation = ({ organizationId, authenticationToken, tenantId }) => async (dispatch) => {
    try {
        await rejectUserInvite({
            authenticationToken,
            tenantId,
            organizationId,
        });

        // reload the user to pickup organization changes 
        dispatch(fetchCurrentUser(authenticationToken));
        dispatch(fetchReceivedInvitations());
    } catch (err) {
        dispatch(addNotification({
            type: notificationTypes.ERROR,
            message: err.message,
            isPersistent: true,
        }));
    }
};

export const removeUser = ({ userId, email }) => async (dispatch, getState) => {

    const { authenticationToken, tenantId } = getState().currentUser;

    dispatch({
        type: actionTypes.ORGANIZATION_LEAVE_REQUESTED,
        payload: {
            userId,
        },
    });

    try {        
        await requestLeaveOrganization({
            authenticationToken,
            userId,
        });

        dispatch(addNotification({
            type: notificationTypes.SUCCESS,
            message: stringReplace(translations.FORG_left_confirmation, { user: email }),
        }));

        // reload the current user in case they have been removed from the current organization 
        await dispatch(fetchCurrentUser(authenticationToken, tenantId));

        // reload the organization users only if the current user is still an admin in the current tenant's organization
        const { currentTenant, currentUser } = getState();

        if (resolveOrgUserRole(currentUser, currentTenant).isUserAdmin) {
            dispatch(fetchUsers());
        }
        
    } catch (error) {

        dispatch(addNotification({
            type: notificationTypes.ERROR,
            message: error.message,
        }));

    } 
};

export const addTenantAndOrUser = ({ authenticationToken, provisionData }) => async (dispatch) => {
    try {
        await provisionTenantAndOrUser({
            authenticationToken,
            provisionData,
        });

        dispatch(addNotification({
            type: notificationTypes.SUCCESS,
            message: translations.FORG_tenant_user_provisioned,
            isPersistent: false,
        }));
    } catch (err) {
        dispatch(addNotification({
            type: notificationTypes.ERROR,
            message: err.message,
            isPersistent: true,
        }));
    } finally {
        dispatch(fetchCurrentUser(authenticationToken));
        dispatch(fetchTenants());
    }
};

export const removeTenant = ({ tenantId }) => async (dispatch, getState) => {

    const { authenticationToken } = getState().currentUser;

    try {
        await removeTenantFromOrg({
            authenticationToken,
            tenantId,
        });
        // reload the current tenant in case it has been removed from the current organization 
        await dispatch(fetchCurrentTenant(authenticationToken, tenantId));

        // reload the organization tenants only if the current tenant is still in the organization
        const { currentTenant } = getState();
        if (currentTenant.organization !== null) {
            dispatch(fetchTenants());
        }
    } catch (err) {
        dispatch(addNotification({
            type: notificationTypes.ERROR,
            message: err.message,
            isPersistent: true,
        }));
    }
};
